"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _angieslistStyles = require("angieslist-styles");

var _default = {
  body: {
    textAlign: 'center',
    margin: _angieslistStyles.stylesTypography.padding.hugest + ' 0',
    color: _angieslistStyles.stylesColors.darkGray
  },
  message: {
    fontSize: _angieslistStyles.stylesTypography.fontSize.hugest
  },
  text404: {
    fontSize: 100,
    color: _angieslistStyles.stylesColors.textBodyLight,
    fontWeight: _angieslistStyles.stylesTypography.fontWeight.xBold
  },
  img: {
    maxWidth: '100%',
    height: 'auto'
  },
  redirect: {
    marginTop: _angieslistStyles.stylesTypography.padding.base
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/error/errorStyles.js
// module id = 1345
// module chunks = 25